
(function(){
  const loadDropdowns = function() {
    const $filterDropdowns = document.querySelectorAll('filter-dropdown');
    if(!$filterDropdowns.length) { return; }

    let _openDropDown;

    const forEachDropdown = function(cb) {
      $filterDropdowns.forEach(cb);
    };

    const openDropdown = function($dropdown) {
      const $dropdownButton = $dropdown.querySelector('button[aria-expanded][aria-controls]');

      $dropdownButton.setAttribute('aria-expanded', 'true');
      _openDropDown = $dropdown;

      document.addEventListener('click', handleOutsideClicks);
    };

    const closeOpenDropdown = function() {
      if (!_openDropDown) { return; }

      const $dropdownButton = _openDropDown.querySelector('button[aria-expanded=true]');

      $dropdownButton.setAttribute('aria-expanded', 'false');
      _openDropDown = null;

      document.removeEventListener('click', handleOutsideClicks);
    }

    const handleOutsideClicks = function(e) {
      const $clickedItem = e.target;
      let relatedToDropdown = false;

      forEachDropdown(function($dropdown) {
        if ($clickedItem === $dropdown || $dropdown.contains($clickedItem)) {
          relatedToDropdown = true;
        }
      });

      if (!relatedToDropdown) {
        closeOpenDropdown();
      }
    };

    const handleDropdownBlur = function(e) {
      if (_openDropDown && e.relatedTarget && !e.relatedTarget.closest('filter-dropdown')) {
        closeOpenDropdown();
      }
    };

    forEachDropdown(function($dropdown) {
      const $button = $dropdown.querySelector('button[aria-expanded][aria-controls]');

      $button.addEventListener('click', function(e) {
        const $clickedBtn = e.currentTarget;
        const isOpen = $clickedBtn.getAttribute('aria-expanded') === 'true';

        if (_openDropDown) {
          closeOpenDropdown();
        }

        if (!isOpen) {
          openDropdown($dropdown);
        }
      });

      $dropdown.addEventListener('focusout', handleDropdownBlur);
    });

    // global event listeners
    document.addEventListener('keydown', function(e) {
      if (e.isComposing) { return; }

      if (e.key === 'Escape') {
        if (_openDropDown) {
          closeOpenDropdown();
        }
      }
    });
  };

  window.addEventListener('load', loadDropdowns);
})();
